import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useCategoriesApi() {
    const callApi = useApiCall();

    return {
        addUpdateCategory: apiCaller(callApi, SAGA_ACTIONS.CATEGORIES.ADD_UPDATE_CATEGORY),
        deleteCategory: apiCaller(callApi, SAGA_ACTIONS.CATEGORIES.DELETE_CATEGORY),
        searchCategory: apiCaller(callApi, SAGA_ACTIONS.CATEGORIES.SEARCH_CATEGORY),
        categoryDetails: apiCaller(callApi, SAGA_ACTIONS.CATEGORIES.CATEGORY_DETAILS),
        rearrangeCategory: apiCaller(callApi, SAGA_ACTIONS.CATEGORIES.REARRANGE_CATEGORY),
    };
}
